import {
  ref, createApp, h,
} from 'vue';

import AsyncDialog from '@/components/Global/AsyncDialog.vue';
import LoadingError from '@/components/Dialog/LoadingError.vue';

export default (requestApi) => {
  const isLoading = ref(false);
  const response = ref({});

  const genErrorDialog = () => new Promise((resolve) => {
    const app = createApp({
      setup() {
        const visible = ref(true);
        const closeSubDialog = (status) => {
          visible.value = false;
          resolve(status);
        };
        return () => h(
          AsyncDialog,
          {
            visible: visible.value,
            'onUpdate:visible': closeSubDialog,
          },
          h(LoadingError),
        );
      },
    });

    const root = document.createElement('div');
    document.body.appendChild(root);

    return {
      instance: app.mount(root),
      unmount() {
        app.unmount(root);
        document.body.removeChild(root);
      },
    };
  });

  const request = async (args = {}, otherArgs = {}) => {
    try {
      isLoading.value = true;
      response.value = await requestApi(args, otherArgs);
      isLoading.value = false;
      return response.value;
    } catch (e) {
      // 錯誤彈窗
      genErrorDialog();
      console.log('e...', e);
    }
    return null;
  };

  return {
    response,
    isLoading,
    request,
  };
};
